import * as _4 from 'lodash4';
import { MetaRankingQuestionFunction } from '../../data/functions/metaranking_fn';
import { ISurveyQuestionItemDTO } from '../../major_explorer_interface';
import { MetaRankingModalService } from '../../modals/metaranking_modal/metaranking_modal_service';

export class SurveyQuestionMetarankingController {
  private mode: string;
  private item: ISurveyQuestionItemDTO;
  private delegateHandle: string;
  private validationCondition: { isValid: () => boolean };
  private modalIndex: number = -1;
  private isModalOpen: boolean = false;

  constructor(
    private $scope: ng.IScope,
    private metaRankingQuestionFn: MetaRankingQuestionFunction,
    private ngMetaRankingModalService: MetaRankingModalService
  ) {}

  $onInit() {
    this.metaRankingQuestionFn.initialize(this.item);
    this.validationCondition = {
      isValid: () => {
        return this.metaRankingQuestionFn.validate(this.item);
      }
    };
  }

  save = () => {
    return this.metaRankingQuestionFn.itemList_onChange(this.item);
  };

  showModal(index: number) {
    this.ngMetaRankingModalService.currentIndex = index;
    this.ngMetaRankingModalService.item = this.item;
    this.ngMetaRankingModalService.isOpen = true;
  }

  valuesChanged(): void {
    this.metaRankingQuestionFn.item_onChange(this.item);
  }

  updateItemList(element: any): void {
    if (!this.isElementDisabled(element)) {
      element._isRanked = !element._isRanked;
      this.metaRankingQuestionFn.updateItemList(this.item);
    }
  }

  hasSelectedMaximumInterests(): boolean {
    return (
      _4.filter(this.item.custom.masterList, (element: any) => {
        return element._isRanked;
      }).length >= this.item.custom._max
    );
  }

  isElementDisabled(element: any): boolean {
    return this.hasSelectedMaximumInterests() && !element._isRanked;
  }
}

export class SurveyQuestionMetarankingComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_metaranking/survey_question_metaranking.html';
  public controller: any = SurveyQuestionMetarankingController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_metaranking/survey_question_metaranking_controller.ts